<template>
  <div>
    <v-card elevation="15" max-width="500" class="mx-auto my-12">
      <div
        class="d-flex flex-column justify-space-between align-center"
        v-if="dataReady"
      >
        <v-container>
          <div id="landing-page">
            <v-img :src="require('@/assets/logoPersonal_LI.jpg')"></v-img>
            <div class="text-center">
              <v-btn
                rounded
                dark
                color="#CA3433"
                depressed
                dense
                @click="pushLogin"
              >
                คลิก
              </v-btn>
            </div>
            <br />
          </div>
        </v-container>
      </div>
    </v-card>
  </div>
</template>
<script>
export default {
  methods: {
    pushLogin () {
      this.$router.push(
        '/Core/Login'
      )
    }
  }
}
</script>
<style>
#landing-page {
  height: 400px;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
}
</style>



// WEBPACK FOOTER //
// src/components/Core/LoginPage.vue